import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import * as files from '@/fileUtils';

export default {
  name: 'PrintReport',
  components: {},
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      reports: [],
      smsDefaultText: '',
      smsEnabled: false,
      lang: ''
    };
  },
  computed: {},
  watch: {},
  created() {
    this.$root.$on('print_report_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        // console.log('this.dataObj', this.dataObj);
        this.appId = this.dataObj.appId;
        this.getReports();
        //this.reports = this.dataObj.appData.reports;
        this.smsDefaultText = this.dataObj.appData.smsDefaultText;
        this.smsEnabled = this.dataObj.appData.smsEnabled;
      });
    },
    viewReport(reportId) {
      var parameters = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        ReportId: reportId
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/PrintReportActivity/GetData', parameters),
        (response) => {
          if (response.status == 200) {
          }
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text)
      );

      //axios.post('/PrintReportActivity/GetData', { ReportId: reportId })
      //  .then(response => {
      //    if (response.status == 200) {
      //      // do nothing
      //      }
      //  })
      //  .catch(error => {
      //   this.$alertMsg(error.response.data);
      //  });
    },
    sendSms() {
      let parameter = {
        Text: this.smsDefaultText,
        Enforced: false,
        ApplicationId: this.appId,
        ApplicationKey: 0
      };
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios
        .post('/PrintReportActivity/SendSms', parameter)
        .then((response) => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.MesssageSentSuccess'), 2);
          }
        })
        .catch((err) => {
          err.response.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.response.data);
        })
        .finally(() => {
          loader.hide();
        });

      //  .then(response => {
      //    if (response.status == 200) {
      //      this.$alertMsg(this.$t('messages.MesssageSentSuccess'), 0);
      //    }
      //  })
      //  .catch(error => {
      //   this.$alertMsg(error.response.data);
      //  });
    },
    getReports() {
      axios
        .get('/EmployeeApplication/GetCurrentActivityReports?applicationId=' + this.appId)
        .then((response) => {
          if (response.status == 200) {
            //console.log(response.data);

            for (let i = 0; i < response.data.items.length; i++) {
              response.data.items[i]['id'] = i;
            }

            this.reports = response.data.items;
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((err) => {
          this.$alertMsg(err.response.data);
          this.$router.push('/login');
        });
    },
    printReport(report) {
      if (report.reportModelType == 0) this.printCrystalReport(report.reportId);
      else if (report.reportModelType == 1) this.printDxReport(report);
    },
    printDxReport(report) {
      var parameters = {
        ApplicationId: this.appId,
        SampleId: '',
        SourceType: '',
        ReportName: report.reportName
      };

      let filename = `${report.description}_${moment().format('DD-MMM-YYYY_HHmm')}_${this.dataObj.appId}`;

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      axios
        .post('/EmployeeApplication/PrepareActivityDxReport', parameters)
        .then((response) => {
          if (response.status == 200) {
            return axios.post('/EmployeeApplication/DownloadActivityDxReport', parameters, { responseType: 'blob' });
          } else this.$alertMsg(response.data.data.text);
        })
        .then((resp) => files.getFile(resp, filename))
        .then((link) => {
          link.click();
        })
        .catch((err) => {
          console.log(err);
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          loader.hide();
        });
    },
    printCrystalReport(reportId) {
      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });

      axios
        .post('/EmployeeApplication/CreateCurrentActivityReport?' + 'ApplicationId=' + this.appId + '&ReportId=' + reportId)
        .then((response) => {
          if (response.status == 200 && response.data.data.status == 0) {
            //console.log(response);

            window.open(response.data.url, '_blank');
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`)
            : this.$alertMsg(err.data.data.text);
        })
        .finally(() => {
          loader.hide();
        });
    }
  }
};
